import { useState, useEffect } from 'react';

/**
 * Hook personalizado para gerenciar o estado de visibilidade da página
 * @returns boolean indicando se a página está visível
 */
export function usePageVisibility(): boolean {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    // Função para atualizar o estado de visibilidade
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
    };

    // Adiciona o listener apenas uma vez na montagem do componente
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup na desmontagem do componente
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isVisible;
} 